import { MCreation } from './creation.m';

export class MWorkspace {
  id: number = 0;
  name: string = '';
  isDefault: boolean = false;
  Creations: MCreation[] = [];
}
